import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import { MODULE_NAME } from '@modules/individuals';
import cx from 'classnames';
import { Ellipsis } from '@common/components/Ellipsis';

import "./questionnaires.styles.scss";

export const Questionnaires = (props) => {
  const { selectedQuestionnaire, onSelectedQuestionnaireChange, title, columns: propsColumns, getFhq4Value, getIdValue } = props;
  const localModuleName = `${MODULE_NAME}-questionnaires-list`;
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    props.getData().then(setData);
  }, []);

  const columns = propsColumns || React.useMemo(
    () =>
      [
        { name: "Questionnaire Name", fieldName: "questionnaireName", width: '50%' },
        { name: "Datasheet Format Name", fieldName: "datasheetFormatName", width: '50%' },
      ].map((x) => ({ ...x, name: I18n.t(x.name) })),
    []
  );
  
  return (
    <div className="IndividualsQuestionnaires">
      <h6 className="IndividualsQuestionnaires__title">{title}</h6>

      <div className="IndividualsQuestionnaires__table">
        <Flex
          justify="space-between"
          alignItems="center"
          className="IndividualsQuestionnaires__table__header"
        >
          {columns.map((x) => (
            <span key={x.fieldName} style={{ width: x.width }} className="IndividualsQuestionnaires__table__header__cell">
              {x.name}
            </span>
          ))}
        </Flex>
        <div className="IndividualsQuestionnaires__table__body">
          {data.map((item, i) => {
            const isSelected = (
              getIdValue(item) && 
              (getIdValue(item) === getIdValue(selectedQuestionnaire)) && 
              (Boolean(getFhq4Value(item)) === Boolean(getFhq4Value(selectedQuestionnaire)))
            );
            
            return (
              <Flex
                justify="space-between"
                alignItems="center"
                key={i}
                className={cx("IndividualsQuestionnaires__table__body__row", { "IndividualsQuestionnaires__table__body__row-selected": isSelected })}
                onClick={isSelected ? undefined : (() => onSelectedQuestionnaireChange(item))}
                {...getTestAttributes(localModuleName, "item", "row")}
              >
                {columns.map((col, i) => {
                  const isNameColumn = col.fieldName === 'questionnaireName';
                  const imgWidth = 16;
                  const imgMargin = 4;

                  return (
                    <React.Fragment key={col.fieldName}>
                      {isNameColumn && <img src="gif/questionnaire.gif" style={{ marginRight: imgMargin, marginLeft: imgMargin }} width={imgWidth} />}
                      <Ellipsis 
                        className="IndividualsQuestionnaires__table__body__row__cell" 
                        width={isNameColumn ? `calc(${col.width} - ${imgWidth + imgMargin * 2}px)` : col.width} 
                        text={item[col.fieldName]} 
                      />
                    </React.Fragment>
                  );
                })}
              </Flex>
            );
          })}
        </div>
      </div>
    </div>
  );
};

Questionnaires.defaultProps = {
  getFhq4Value: (item) => item?.fhq4,
  getIdValue: (item) => item?.questionnaireId,
};